import type { ReactNode } from 'react';

export enum MFAType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export interface MFACodeFormProps {
  handleResendCode?: () => void;
  helperText?: ReactNode;
  isSubmitting?: boolean;
  isResending?: boolean;
  resendCooldownSeconds?: number;
  submitLabel?: string;
  fieldName?: string;
}
